<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="back" class="btn-back" @click="$router.go(-1)">Back</ion-button>
          <ion-button v-if="!back" class="btn-back" @click="$router.back()">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="1"></bg>
      <ion-grid>
        <form @submit="save" class="row-boxed mt-20">
          <ion-row class="mb-20">
            <ion-col size="12" class="text-right">
              <ion-button @click="loadTemplate" type="button">LOAD TEMPLATE</ion-button>
            </ion-col>
          </ion-row>

          <!--
          <pre class="text-left">{{ indicesSave }}</pre>
          <br><br><br>
          <pre class="text-left">{{ indices }}</pre>
          -->
          <div class="fix-padded">
            <nested-draggable :k="0" @add="(i) => add(i)" :indices="indices" v-if="indices" type="index"></nested-draggable>
          </div>

          <ion-row>
            <ion-col size="12" class="text-right">
              <ion-button @click="saveTemplate" type="button">SAVE AS TEMPLATE</ion-button>
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import nestedDraggable from './partials/Nested'
export default {
  name: "NewYachtIndex",
  components: {
    nestedDraggable
  },
  data: function() {
    return {
      indices: [],
      templates: [],
      loader: true,
      back: this.$route.params.back ? this.$route.params.back : false,
    }
  },
  computed: {
    indicesSave: function(){
      let indices = JSON.parse(JSON.stringify(this.indices))
      let indicesSave = []
      indicesSave = indicesSave.concat(this.splitIndices(indices, ''))
      return indicesSave
    }
  },
  methods: {
    splitIndices: function(arrayLoop, parent){
      let indicesSave = []
      if(arrayLoop.length) {
        let x = 0
        while (x < arrayLoop.length) {
          arrayLoop[x].parent = parent
          indicesSave.push(arrayLoop[x])
          if(arrayLoop[x].indices.length) {
            parent = arrayLoop[x].cod
            indicesSave = indicesSave.concat(this.splitIndices(arrayLoop[x].indices, parent))
            parent = ''
          }
          x++
        }
      }
      return indicesSave
    },
    loadTemplate() {
      let inputs = []
      let i = 0
      while (i < this.templates.length) {
        let obj = {
          type: 'radio',
          value: this.templates[i].template,
          label: this.templates[i].template,
        }
        inputs.push(obj)
        i++
      }

      return this.$ionic.alertController
      .create({
        header: 'Choose a template',
        inputs: inputs,
        buttons: [
          {
            text: 'Back',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              // this.$router.back()
            },
          },
          {
            text: 'Import',
            handler: (value) => {
              this.loader = true
              axios.post(this.apiUrl + '/api/v1/get-indices', { api_token: this.$store.state.api_token, name: value })
              .then((response) => {
                this.indices = []
                let res = response.data
                if(res.data.length) {
                  let i = 0
                  while (i < res.data.length) {
                    res.data[i].id = ''
                    res.data[i].yacht_id = ''
                    res.data[i].template = ''
                    delete res.data[i].created_at
                    delete res.data[i].updated_at
                    Vue.set(this.indices, this.indices.length, res.data[i]);
                    i++
                  }
                } else {
                  // Non sono presenti indici, creo una riga vuota
                  this.add()
                }
                this.loader = false
              })

            },
          },
        ]
      })
      .then(a => a.present())
    },
    saveTemplateApi(name) {
      this.loader = true;
      axios.post(this.apiUrl + '/api/v1/save-indices-template', { api_token: this.$store.state.api_token, indices: this.indicesSave, name: name })
      .then(async(response) => {
        let res = response.data
        if(res.status == 1) {
          const toast = await this.$ionic.toastController.create({
            message: 'Template saved succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
        this.loader = false;

        const toast = await this.$ionic.toastController.create({
          message: 'Template saved succesfully',
          color: 'success',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      })
    },
    async saveTemplate() {
      if(!this.checkCod()) {
        return this.$ionic.alertController
        .create({
          header: 'Save template',
          inputs: [
            {
              name: 'name',
              id: 'name',
              placeholder: 'Template name',
            },
          ],
          buttons: [
            {
              text: 'Back',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                // this.$router.back()
              },
            },
            {
              text: 'Save',
              handler: async(value) => {
                let name = value.name
                if(name) {
                  this.loader = true;
                  axios.post(this.apiUrl + '/api/v1/check-template-name', { api_token: this.$store.state.api_token, name: name })
                  .then(async(response) => {
                    let res = response.data
                    if(res.data.exist == 1) {
                      return this.$ionic.alertController
                      .create({
                        header: 'A template with the same name already exists. Do you want to overwrite it?',
                        buttons: [
                          {
                            text: 'No',
                            role: 'cancel',
                            cssClass: 'secondary',
                            handler: async() => {
                              this.loader = false
                            },
                          },
                          {
                            text: 'Yes',
                            handler: async() => {
                              this.saveTemplateApi(name)
                            },
                          },
                        ],
                      })
                      .then(a => a.present())
                    } else {
                      this.saveTemplateApi(name)
                    }
                  })
                } else {
                  const toast = await this.$ionic.toastController.create({
                    message: 'Template name is required',
                    color: 'danger',
                    position: 'bottom',
                    duration: 3000
                  })
                  await toast.present();
                  this.insert()
                }
              },
            },
          ],
        })
        .then(a => a.present())
      } else {
        const toast = await this.$ionic.toastController.create({
          message: '"cod" or "ref" required in all indices',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      }
    },
    checkCod() {
      let i = 0
      let error = false
      while (i < this.indicesSave.length) {
        if(!this.indicesSave[i].cod && !this.indicesSave[i].ref) {
          error = true
        }
        i++
      }
      return error
    },
    async save(ev) {
      ev.preventDefault();
      if(!this.checkCod()) {
        this.loader = true;
        axios.post(this.apiUrl + '/api/v1/save-indices', { api_token: this.$store.state.api_token, indices: this.indicesSave, report_id: this.$route.params.id })
        .then(async(response) => {
          let res = response.data
          if(res.data) {
            const toast = await this.$ionic.toastController.create({
              message: 'Index updated succesfully',
              color: 'success',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
          this.loader = false;
        })
      } else {
        const toast = await this.$ionic.toastController.create({
          message: '"cod" or "ref" required in all indices',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      }
    },
    add() {
      let obj = {
        id: '',
        report_id: '',
        ref: '',
        cod: '',
        title: '',
        type: '',
        parent: '',
        order: '',
        user_id_added: '',
        user_id_edited: '',
        indices: [],
      }
      Vue.set(this.indices, this.indices.length, obj);
    },
  },
  mounted: async function() {
    await axios.post(this.apiUrl + '/api/v1/get-indices', { api_token: this.$store.state.api_token, id: this.$route.params.id })
    .then((response) => {
      let res = response.data
      if(res.data.length) {
        let i = 0
        while (i < res.data.length) {
          Vue.set(this.indices, this.indices.length, res.data[i]);
          i++
        }
      } else {
        // Non sono presenti indici, creo una riga vuota
        this.add()
      }
    })

    await axios.post(this.apiUrl + '/api/v1/get-templates', { api_token: this.$store.state.api_token })
    .then((response) => {
      let res = response.data
      if(res.data) {
        this.templates = res.data
      }
    })

    this.loader = false;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>